export default "__VITE_ASSET__BeVFcel7__"